<template>
	<div v-if="status" class="ui-status" :class="[ status.slug ]" v-hammer:tap="display_status">
		<div class="icon" v-bg="'ui/' + status.slug + '.png'"></div>
		<div class="value">{{ status.value }}</div>
		<ui-tooltip :title="status[lang].name" :text="status[lang].description" :value="status.value" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UiTooltip from '@/components/ui/ui-tooltip'

export default {
	name: 'ui-status',
	props: {
		status: { default: null },
	},
	computed: {
		...mapGetters([ 'lang' ]),
		illustration() {
			return ''
		}
	},
	methods: {
		display_status() {
			this.$store.dispatch('add_status_info', { status_info: this.status })
		}
	},
	components: { UiTooltip }
}
</script>

<style lang="stylus" scoped>

.ui-status
	display inline-block
	width 32px
	height 32px
	flex center center
	font-size 2.8rem
	&:hover
		>>> .ui-tooltip
			visibility visible
	&.poison .icon
		transform scaleX(-1)
	.icon
		absolute 0
		background center center no-repeat
		background-size contain
	.value
		position absolute
		right -2px
		bottom -6px
		color dark
		c = #fff
		text-shadow -1px -1px c, -1px 1px c, 1px -1px c, 1px 1px c
			

</style>
